import { createContext, useContext } from 'react'

import {
  SiteAuditDocumentsReportFilterParams,
  SiteAuditDocumentsReportResponse
} from '~bank-reports/types/SiteAuditDocumentsReport'

type SiteAuditDocumentsReportContextValue = {
  data: SiteAuditDocumentsReportResponse
  isPending: boolean
  successFullyLoaded: boolean
  state: SiteAuditDocumentsReportFilterParams
  navigate: (searchParams: Partial<SiteAuditDocumentsReportFilterParams>) => Promise<void>
  clear: () => void
}

export const SiteAuditDocumentsReportContext = createContext<SiteAuditDocumentsReportContextValue | null>(null)

export const useSiteAuditDocumentsReportContext = () => {
  const context = useContext(SiteAuditDocumentsReportContext)

  if (!context) {
    throw new Error('useSiteAuditDocumentsReportContext must be used within a SiteAuditDocumentsReportContext.Provider')
  }

  return context
}
